var map = {
	"./android-icon.svg": 5603,
	"./bank_transfer.png": 1581,
	"./bar.svg": 8882,
	"./bhim-upi-icon.png": 3664,
	"./coins-icon.png": 6190,
	"./defaultAvatar.jpeg": 2635,
	"./dep.svg": 8631,
	"./deposit#00E7FF.png": 4481,
	"./deposit#06D0C2.png": 4829,
	"./deposit#268368.png": 7375,
	"./deposit#288268.png": 325,
	"./deposit#34d5f5.png": 7995,
	"./deposit#DB9928.png": 2974,
	"./deposit#F49D1A.png": 3483,
	"./deposit#FA6800.png": 6392,
	"./deposit#FEB139.png": 6551,
	"./deposit#FFB902.png": 3297,
	"./deposit#FFCE00.png": 373,
	"./deposit#e4a22a.png": 3291,
	"./deposit#ff8f00.png": 675,
	"./deposit_icon.png": 2027,
	"./dot.svg": 6345,
	"./download-add-popup.png": 4158,
	"./download.png": 7361,
	"./download.svg": 9373,
	"./empty-box-1.png": 4753,
	"./empty-box.png": 8850,
	"./error.png": 6138,
	"./gpay.svg": 9860,
	"./help-desk.svg": 2414,
	"./icons8-india-48.png": 5825,
	"./image1.png": 7722,
	"./image2.png": 9268,
	"./image3.png": 319,
	"./india.png": 8803,
	"./l6.png": 7993,
	"./landingPage/landing_1-1.png": 2437,
	"./landingPage/landing_2-1.png": 4061,
	"./landingPage/landing_3.png": 5436,
	"./landingPage/landing_4.png": 2011,
	"./landingPage/landing_7upDown.webp": 9600,
	"./landingPage/landing_cricket.webp": 5637,
	"./landingPage/landing_ic1.png": 1195,
	"./landingPage/landing_ic2.png": 1183,
	"./landingPage/landing_ic3.png": 1966,
	"./landingPage/landing_ic4.png": 5143,
	"./landingPage/landing_ic5.png": 8213,
	"./landingPage/landing_ic6.png": 3194,
	"./landingPage/landing_slider1.webp": 8399,
	"./landingPage/landing_soccer.webp": 9137,
	"./landingPage/landing_teenPatti.webp": 9705,
	"./landingPage/landing_tennis.webp": 9959,
	"./landingPage/ourGames_7updown.jpeg": 3660,
	"./landingPage/ourGames_amarakbarantony.jpeg": 501,
	"./landingPage/ourGames_andarbahar.jpeg": 6141,
	"./landingPage/ourGames_bollywood_casino.jpeg": 7898,
	"./landingPage/ourGames_card_casino.jpeg": 1590,
	"./landingPage/ourGames_dragontiger.jpeg": 2967,
	"./landingPage/ourGames_highlow.jpeg": 2910,
	"./landingPage/ourGames_matka_virtual.jpeg": 4744,
	"./landingPage/ourGames_patti_oneday.jpeg": 1403,
	"./landingPage/ourGames_poker.jpeg": 2698,
	"./landingPage/ourGames_race2020.jpeg": 7724,
	"./landingPage/ourGames_sixplayer_poker.jpeg": 213,
	"./logo.jpeg": 2988,
	"./logo.png": 1053,
	"./logopath.png": 8825,
	"./menu-apk-option.svg": 4055,
	"./no-pictures.png": 7739,
	"./noOffer.png": 6172,
	"./online-payment.png": 7880,
	"./otp-bg.png": 8936,
	"./payment-failure.svg": 6456,
	"./payment-pending.svg": 1329,
	"./payment-success.svg": 2073,
	"./paytm.svg": 5250,
	"./pexels-jurie-maree-5519470 1.png": 4576,
	"./phonepe.svg": 6130,
	"./qr.png": 341,
	"./refer.jpg": 9129,
	"./responsive-icon.svg": 5119,
	"./success.png": 20,
	"./upi.png": 7513,
	"./upi.svg": 4254,
	"./whatsapp.svg": 8364,
	"./wid.svg": 2926,
	"./withdraw#00E7FF.png": 6004,
	"./withdraw#06D0C2.png": 1724,
	"./withdraw#268368.png": 1617,
	"./withdraw#288268.png": 884,
	"./withdraw#34d5f5.png": 3213,
	"./withdraw#DB9928.png": 2649,
	"./withdraw#F49D1A.png": 9557,
	"./withdraw#FA6800.png": 4589,
	"./withdraw#FEB139.png": 3772,
	"./withdraw#FFB902.png": 8533,
	"./withdraw#FFCE00.png": 4211,
	"./withdraw#e4a22a.png": 3775,
	"./withdraw#ff8f00.png": 9206,
	"./withdraw_icon.png": 3963
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1327;